import { z } from 'zod';
/**
 * Assiette de la remise d'un code promo. Bascule runtime depuis le back-office
 * (table `app_settings`, clé `promo_discount_scope`), globale et non par code.
 *
 * Reprend à l'identique les valeurs de l'enum Prisma `PromoDiscountScope` :
 * le réglage global et le snapshot porté par chaque dossier parlent la même langue.
 */
export const promoDiscountScopeSchema = z.enum(['PER_PASSENGER', 'PER_BOOKING']);
export const updatePromoSettingsSchema = z.object({
    discountScope: promoDiscountScopeSchema,
});
